import React from 'react';
// This is the key part: the Group control needs the factory to render its children.
import { ControlPreviewFactory } from '../ControlPreviewFactory';
import {
  StyledGroupContainer,
  StyledGroupHeader,
  GroupChildrenContainer
} from './styles/Group.styles';

const GroupControl = (props) => {
  const { control, renderMode, isSelected, onSendToBack } = props;

  return (
    <StyledGroupContainer styleProps={control.attributes.container}>
      {control.hasTitle && (
        <StyledGroupHeader styleProps={control.attributes.header}>
          {control.titleText}
        </StyledGroupHeader>
      )}
      <GroupChildrenContainer>
        {control.children?.map(childControl => (
          <ControlPreviewFactory
            key={childControl.id}
            control={{ ...childControl, isPlaced: control.isPlaced }}
            renderMode={renderMode}
            isSelected={isSelected}
            onSendToBack={onSendToBack}
            // Children inside a group are never individually draggable
            isDraggable={false}
          />
        ))}
      </GroupChildrenContainer>
    </StyledGroupContainer>
  );
};

export default GroupControl;